import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService, UserConfiguration } from 'src/app/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private authService = inject(AuthService);

  public config$: Observable<UserConfiguration> = this.authService.userConfiguration$;

  constructor() {}

  /**
   * Get the full configuration object as an observable.
   */
  getFullConfig(): Observable<UserConfiguration> {
    return this.config$;
  }

  /**
   * Get a specific value from the configuration.
   * @param key The key of the configuration value to get.
   */
  getConfigValue<K extends keyof UserConfiguration>(key: K): Observable<UserConfiguration[K]> {
    return this.config$.pipe(map((config) => (config ? config[key] : this.authService.getDefaultUserConfiguration()[key])));
  }

  /**
   * Update a part of the user configuration.
   * @param partialConfig The partial configuration to update.
   */
  async updateConfig(partialConfig: Partial<UserConfiguration>): Promise<unknown> {
    const currentConfig = await this.authService.getUserConfigurationDocument();
    const newConfig = { ...currentConfig, ...partialConfig };
    return this.authService.setUserConfigurationDocument(newConfig);
  }

  /**
   * Get a snapshot of the current configuration.
   */
  async getCurrentConfig(): Promise<UserConfiguration> {
    return this.authService.getUserConfigurationDocument();
  }
}
